export default __webpack_public_path__ + "static/media/Info.67cc6914.svg";